export async function loadExerciseCatalog(fetcher = fetch) {
  const response = await fetcher('/api/exercises');
  if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) {
    throw new Error('No se pudo cargar el catálogo de ejercicios. Comprueba la conexión y vuelve a intentarlo.');
  }
  const catalog = await response.json();
  if (!catalog || Array.isArray(catalog) || typeof catalog !== 'object' || !Object.values(catalog).length || Object.values(catalog).some(item => !item?.id || !item?.name)) {
    throw new Error('El catálogo de ejercicios no está disponible. Vuelve a intentarlo en unos momentos.');
  }
  return catalog;
}
